import { render } from "./AssignProjectPopup.vue?vue&type=template&id=3ebc6ad3&scoped=true&ts=true"
import script from "./AssignProjectPopup.vue?vue&type=script&lang=ts"
export * from "./AssignProjectPopup.vue?vue&type=script&lang=ts"

import "./AssignProjectPopup.vue?vue&type=style&index=0&id=3ebc6ad3&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebc6ad3"]])

export default __exports__